import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Carousel from "./Carousel";
export const Legends = ({ id, testId, onPrevious, onNext, children, }) => {
    const childrenArray = React.Children.toArray(children);
    return (_jsx("div", { id: id, "data-test-id": testId, "data-eco-component": "eco-legends", className: "bg-container-light dark:bg-dark-container-light", children: _jsx(Carousel, { items: childrenArray, onNext: onNext, onPrevious: onPrevious }) }));
};
